import React from 'react'

import '../css/Answer.css'

class Answer extends React.Component {
    render() {
        return (
            <div className='answer'></div>
        )
    }
}

export default Answer